import { TCurrentLocation } from '../../shared/types/location';

export const MoscowId = 1;
export const MOId = 4593;
export const LOId = 4588;
export const moscowMoIds = [MoscowId, MOId];
export const spbLoIds = [2, LOId];

export function isDealRentEnabled(location: TCurrentLocation) {
  const regionId = getRegionId(location);

  return [...moscowMoIds, ...spbLoIds, -1, -2].includes(regionId);
}

export function getRegionId(location: TCurrentLocation) {
  if (location === 'moscow_mo') {
    return -1;
  }
  if (location === 'spb_lo') {
    return -2;
  }

  return location.parentId || location.id;
}
